// extracted by css-extract-rspack-plugin
var _1 = "iH8rJhBISxsZKQei";
export { _1 as "iconStyle" }
// extracted by css-extract-rspack-plugin
var _1 = "iH8rJhBISxsZKQei";
export { _1 as "iconStyle" }
